import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Category from "../pages/category/page";
import Detail from "../pages/detail/page";
import Search from "../pages/search/page";
import Topic from "../pages/topic/page";
import About from "../pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/category",
    element: <Category />,
  },
  {
    path: "/detail/:id",
    element: <Detail />,
  },
  {
    path: "/search",
    element: <Search />,
  },
  {
    path: "/topic",
    element: <Topic />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;